import { FunctionComponent, CSSProperties, ChangeEvent } from 'react';
import { FieldError } from 'react-hook-form/dist/index.ie11';

interface FormGroupTextareaProps {
  id: string;
  name: string;
  rows: number;
  required: boolean;
  labelText: string;
  className?: string;
  placeholder: string;
  error?: FieldError;
  defaultValue?: string | number | string[] | undefined;
  onChange: (event: ChangeEvent<HTMLTextAreaElement>) => void;
  style?: CSSProperties;
}

const FormGroupTextarea: FunctionComponent<FormGroupTextareaProps> = ({
  id,
  name,
  rows,
  required,
  labelText,
  className,
  placeholder,
  error,
  defaultValue,
  onChange,
  style,
}) => (
  <div
    className={`c-form-group${error ? ' is-invalid' : ' is-valid'}`}
    style={style}
  >
    <label htmlFor={id} className="c-form-group__label">
      {labelText} {required && <span className="is-required">*</span>}
    </label>

    <span className="c-form-group__invalid u-ml-1">{error?.message}</span>

    <textarea
      name={name}
      id={id}
      rows={rows}
      className={`c-form-control${className || ''}`}
      placeholder={placeholder}
      defaultValue={defaultValue}
      onChange={onChange}
      required={required}
    />
  </div>
);

export default FormGroupTextarea;
